import { createFileRoute } from '@tanstack/react-router';

import { ClientDetailsForm } from '@/features/risk-assessment/components/client-details-form';

export const Route = createFileRoute('/_authenticated/risk-assessment/$id/client-details')({
  component: ClientDetailsPage,
});

function ClientDetailsPage() {
  const { id } = Route.useParams();
  return <ClientDetailsForm assessmentId={id} />;
}
